import React from 'react';
import { Link } from 'react-router-dom';
import ThemeSwitcher from '@/components/ThemeSwitcher/index';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import styles from './styles.module.scss';

interface AuthLayoutProps {
  title: string;
  children: React.ReactNode;
  showHeader?: boolean;
  pitch?: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, pitch }) => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.siteHeader}>
        <div className={styles.headerInner}>
          <Link className={styles.logo} to="/" aria-label="PClash home">
            <span className={styles.logoPlay}><span>PClash</span></span>
          </Link>
          <div className="d-flex align-items-center g-8">
            <LanguageSwitcher />
            <ThemeSwitcher />
          </div>
        </div>
      </header>
      <main className={styles.authShell}>
        <div className={`${styles.authGrid} ${pitch ? styles.authGridSplit : ''}`}>
          {pitch && <section className={styles.pitch}>{pitch}</section>}
          <section className={styles.formCol}>
            {children}
          </section>
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
